// src/components/whiteLabelForm.jsx
import React, { useState } from 'react';
import { Card, Stack, TextField, Typography, Button } from '@mui/material';

export default function WhiteLabelForm({
  defaultPrimary = '#0A68FF',
  defaultCompany = '',
  defaultClient  = '',
  onApply,
  title = 'White Label',
  showCompany = true,
  showClient  = true,
}) {
  const [primary, setPrimary] = useState(defaultPrimary);
  const [company, setCompany] = useState(defaultCompany);
  const [client,  setClient]  = useState(defaultClient);

  const apply = () => onApply?.({ primary, company, client });
  const reset = () => {
    setPrimary(defaultPrimary);
    setCompany(defaultCompany);
    setClient(defaultClient);
    onApply?.({ primary: defaultPrimary, company: defaultCompany, client: defaultClient });
  };

  return (
    <Card className="no-print" sx={{ p: 2, boxShadow: 0, border: '1px solid rgba(0,0,0,0.08)' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>{title}</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          <input
            type="color"
            value={primary}
            onChange={(e) => setPrimary(e.target.value)}
            style={{ width: 40, height: 40, border: 'none', background: 'transparent', cursor: 'pointer' }}
            aria-label="Primary color"
          />
          <TextField
            size="small"
            label="Primary (hex)"
            value={primary}
            onChange={(e) => setPrimary(e.target.value)}
          />
        </Stack>
        {showCompany && (
          <TextField size="small" label="Company" value={company} onChange={(e) => setCompany(e.target.value)} />
        )}
        {showClient && (
          <TextField size="small" label="Client" value={client} onChange={(e) => setClient(e.target.value)} />
        )}
        <Button variant="contained" onClick={apply}>Apply</Button>
        <Button variant="outlined" onClick={reset}>Reset</Button>
      </Stack>
    </Card>
  );
}
